import { render } from "./show.vue?vue&type=template&id=429a6ffb&scoped=true"
import script from "./show.vue?vue&type=script&lang=js"
export * from "./show.vue?vue&type=script&lang=js"

import "./show.vue?vue&type=style&index=0&id=429a6ffb&lang=scss&scoped=true"
import "./show.vue?vue&type=style&index=1&id=429a6ffb&lang=css"

import exportComponent from "/data/jenkins/workspace/talk-community-h5-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-429a6ffb"]])

export default __exports__